import { render, staticRenderFns } from "./RawField.vue?vue&type=template&id=3947de7c&scoped=true"
import script from "./RawField.vue?vue&type=script&lang=js"
export * from "./RawField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3947de7c",
  null
  
)

export default component.exports